<template>
    <div class="ArchiveInfo">
        <el-form :key="112" :model="vo" @submit.native.prevent>
            <div style="font-size: 14px;padding-left: 10px;margin-bottom: 10px;border-left: 3px solid var(--subjectColor);">基本信息</div>
            <div style="width: 100%" class="el-table el-table--fit el-table--border">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                        <tbody>
                            <!-- <tr>
                                <td style="background: #f2f5fb" class="el-table__cell" colspan="6">
                                    <div class="slicer">基本信息</div>
                                </td>
                            </tr> -->
                            <tr>
                                <td ref="tdlbl_姓名" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'name'" class="field">姓名</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">

                                    <div v-if="canEdit && !isMypersonalRecords">
                                        <ValidationProvider v-if="canEdit === 1" ref="ValidationProvider" v-slot="{ errors }" name="姓名" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-input v-model="vo.name" v-select-dialog="'staff'" placeholder="请选择或输入姓名" name="staff" />
                                        <!-- <el-input v-model="vo.name" placeholder="请选择或输入姓名" class="input-with-select">
                                <el-button slot="append" icon="el-icon-more" @click="selectStaff(vo,0,'选择人员')"></el-button>
                            </el-input> -->
                                        </el-tooltip>
                                    </ValidationProvider>
                                    </div>

                                    <div v-else>
                                        {{ vo.name }}
                                    </div>
                                    <!-- <form-item ref="name" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入姓名','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'姓名','propName':'name','propType':'String','textFormatter':'textfield','valueMaxLength':50,'valueMinLength':null,'model':'vo.name','option':[]}" :vo="vo" :can-edit="canEdit" /> -->
                                </td>
                                <td ref="tdlbl_性别 " class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'sex'" class="field">性别</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="sex"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '0：女\n1：男',
                                            elementReadonly: 1,
                                            elementType: 'radio',
                                            emptyMessage: '请选择性别 ',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '性别 ',
                                            propName: 'sex',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.sex',
                                            option: [
                                                { value: '0', name: '女' },
                                                { value: '1', name: '男' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: true,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_证件照片" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'idPhoto'" class="field">证件照片</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="idPhoto"
                                        :field="{
                                            defaultValue: 'certificatesName',
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: null,
                                            elementType: 'file',
                                            emptyMessage: '请选择证件照片',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 0,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '证件照片',
                                            propName: 'idPhoto',
                                            propType: 'byte[]',
                                            textFormatter: '.jpg,.png',
                                            valueMaxLength: 50,
                                            valueMinLength: null,
                                            model: 'vo.idPhoto',
                                            option: [],
                                            downloadUrl: '/rsgl/archiveInfo/download',
                                            nameField: 'certificatesName',
                                            limitCount: null
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                    <!-- <el-upload
                                    class="avatar-uploader"
                                    action=""
                                    :show-file-list="false"
                                        :disabled="!canEdit"
                                    :on-change="handleUploadChange"
            >
                                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload> -->
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_身份证号" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'idCardNumber'" class="field">身份证号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="idCardNumber"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入身份证号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '身份证号', propName: 'idCardNumber', propType: 'String', textFormatter: 'card', valueMaxLength: 30, valueMinLength: null, model: 'vo.idCardNumber', option: [], autocomplete: 'off', showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_出生日期 " class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'birthday'" class="field">出生日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="birthday"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: 'format：yyyy年MM月dd日\r\n', elementReadonly: 1, elementType: 'date', emptyMessage: '请输入出生日期 ', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '出生日期 ', propName: 'birthday', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日\r\n', valueMaxLength: null, valueMinLength: null, model: 'vo.birthday', option: [], weekday: 0 }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_年龄" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'age'" class="field">年龄</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="age"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入年龄', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '年龄', propName: 'age', propType: 'Short', textFormatter: 'integer', valueMaxLength: null, valueMinLength: null, model: 'vo.age', option: [], autocomplete: 'off', showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_婚姻情况 " class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'marriage'" class="field">婚姻情况</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="marriage"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '0：未婚\n1：已婚\n2：离异',
                                            elementReadonly: 1,
                                            elementType: 'radio',
                                            emptyMessage: '请选择婚姻情况 ',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '婚姻情况 ',
                                            propName: 'marriage',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.marriage',
                                            option: [
                                                { value: '0', name: '未婚' },
                                                { value: '1', name: '已婚' },
                                                { value: '2', name: '离异' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: true,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_政治面貌" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'politicalOutlook'" class="field">政治面貌</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="politicalOutlook"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：群众\n2：共青团员\n3：预备党员\n4：共产党员',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择政治面貌',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '政治面貌',
                                            propName: 'politicalOutlook',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: 20,
                                            valueMinLength: null,
                                            model: 'vo.politicalOutlook',
                                            option: [
                                                { value: '1', name: '群众' },
                                                { value: '2', name: '共青团员' },
                                                { value: '3', name: '预备党员' },
                                                { value: '4', name: '共产党员' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: true,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_籍贯" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'nativePlace'" class="field">籍贯</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="nativePlace"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入籍贯',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '籍贯',
                                            propName: 'nativePlace',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: 100,
                                            valueMinLength: null,
                                            model: 'vo.nativePlace',
                                            option: [],
                                            autocomplete: 'off',
                                            showWordLimit: false,
                                            dialog: 0,
                                            dialogNLevelFilter: '2'
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_民族" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'nation'" class="field">民族</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="nation"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter:
                                                '汉族：汉族\n满族：满族\n蒙古族：蒙古族\n回族：回族\n藏族：藏族\n维吾尔族：维吾尔族\n苗族：苗族\n彝族：彝族\n壮族：壮族\n布依族：布依族\n侗族：侗族\n瑶族：瑶族\n白族：白族\n土家族：土家族\n哈尼族：哈尼族\n哈萨克族：哈萨克族\n傣族：傣族\n黎族：黎族\n傈僳族：傈僳族\n佤族：佤族\n畲族：畲族\n高山族：高山族\n拉祜族：拉祜族\n水族：水族\n东乡族：东乡族\n纳西族：纳西族\n景颇族：景颇族\n柯尔克孜族：柯尔克孜族\n土族：土族\n达斡尔族：达斡尔族\n仫佬族：仫佬族\n羌族：羌族\n布朗族：布朗族\n撒拉族：撒拉族\n毛南族：毛南族\n仡佬族：仡佬族\n锡伯族：锡伯族\n阿昌族：阿昌族\n普米族：普米族\n朝鲜族：朝鲜族\n塔吉克族：塔吉克族\n怒族：怒族\n乌孜别克族：乌孜别克族\n俄罗斯族：俄罗斯族\n鄂温克族：鄂温克族\n德昂族：德昂族\n保安族：保安族\n裕固族：裕固族\n京族：京族\n塔塔尔族：塔塔尔族\n独龙族：独龙族\n鄂伦春族：鄂伦春族\n门巴族：门巴族\n珞巴族：珞巴族\n基诺族：基诺族',
                                            elementReadonly: 0,
                                            elementType: 'select',
                                            emptyMessage: '请输入民族',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 8,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '民族',
                                            propName: 'nation',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: 30,
                                            valueMinLength: null,
                                            model: 'vo.nation',
                                            option: [
                                                { value: '汉族', name: '汉族' },
                                                { value: '满族', name: '满族' },
                                                { value: '蒙古族', name: '蒙古族' },
                                                { value: '回族', name: '回族' },
                                                { value: '藏族', name: '藏族' },
                                                { value: '维吾尔族', name: '维吾尔族' },
                                                { value: '苗族', name: '苗族' },
                                                { value: '彝族', name: '彝族' },
                                                { value: '壮族', name: '壮族' },
                                                { value: '布依族', name: '布依族' },
                                                { value: '侗族', name: '侗族' },
                                                { value: '瑶族', name: '瑶族' },
                                                { value: '白族', name: '白族' },
                                                { value: '土家族', name: '土家族' },
                                                { value: '哈尼族', name: '哈尼族' },
                                                { value: '哈萨克族', name: '哈萨克族' },
                                                { value: '傣族', name: '傣族' },
                                                { value: '黎族', name: '黎族' },
                                                { value: '傈僳族', name: '傈僳族' },
                                                { value: '佤族', name: '佤族' },
                                                { value: '畲族', name: '畲族' },
                                                { value: '高山族', name: '高山族' },
                                                { value: '拉祜族', name: '拉祜族' },
                                                { value: '水族', name: '水族' },
                                                { value: '东乡族', name: '东乡族' },
                                                { value: '纳西族', name: '纳西族' },
                                                { value: '景颇族', name: '景颇族' },
                                                { value: '柯尔克孜族', name: '柯尔克孜族' },
                                                { value: '土族', name: '土族' },
                                                { value: '达斡尔族', name: '达斡尔族' },
                                                { value: '仫佬族', name: '仫佬族' },
                                                { value: '羌族', name: '羌族' },
                                                { value: '布朗族', name: '布朗族' },
                                                { value: '撒拉族', name: '撒拉族' },
                                                { value: '毛南族', name: '毛南族' },
                                                { value: '仡佬族', name: '仡佬族' },
                                                { value: '锡伯族', name: '锡伯族' },
                                                { value: '阿昌族', name: '阿昌族' },
                                                { value: '普米族', name: '普米族' },
                                                { value: '朝鲜族', name: '朝鲜族' },
                                                { value: '塔吉克族', name: '塔吉克族' },
                                                { value: '怒族', name: '怒族' },
                                                { value: '乌孜别克族', name: '乌孜别克族' },
                                                { value: '俄罗斯族', name: '俄罗斯族' },
                                                { value: '鄂温克族', name: '鄂温克族' },
                                                { value: '德昂族', name: '德昂族' },
                                                { value: '保安族', name: '保安族' },
                                                { value: '裕固族', name: '裕固族' },
                                                { value: '京族', name: '京族' },
                                                { value: '塔塔尔族', name: '塔塔尔族' },
                                                { value: '独龙族', name: '独龙族' },
                                                { value: '鄂伦春族', name: '鄂伦春族' },
                                                { value: '门巴族', name: '门巴族' },
                                                { value: '珞巴族', name: '珞巴族' },
                                                { value: '基诺族', name: '基诺族' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: true,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_手机号码" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'mobilePhone'" class="field">手机号码</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="mobilePhone"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入手机号码', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '手机号码', propName: 'mobilePhone', propType: 'String', textFormatter: 'phone', valueMaxLength: 15, valueMinLength: null, model: 'vo.mobilePhone', option: [], autocomplete: 'off', showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_邮箱地址" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'email'" class="field">邮箱地址</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="email"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入邮箱地址', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '邮箱地址', propName: 'email', propType: 'String', textFormatter: 'email', valueMaxLength: 100, valueMinLength: null, model: 'vo.email', option: [], autocomplete: 'off', showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_毕业学校" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'graduatedSchool'" class="field">毕业学校</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="graduatedSchool"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入毕业学校', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '毕业学校', propName: 'graduatedSchool', propType: 'String', textFormatter: 'textfield', valueMaxLength: 50, valueMinLength: null, model: 'vo.graduatedSchool', option: [], autocomplete: 'off', showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_最高学历 " class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'educational'" class="field">最高学历</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="educational"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：研究生\n2：大学本科\n3：大专\n4：中专\n5：高中\n6：初中\n7：其他',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择最高学历',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '最高学历 ',
                                            propName: 'educational',
                                            propType: 'String',
                                            textFormatter: null,
                                            valueMaxLength: 50,
                                            valueMinLength: null,
                                            model: 'vo.educational',
                                            option: [
                                                { value: '1', name: '研究生' },
                                                { value: '2', name: '大学本科' },
                                                { value: '3', name: '大专' },
                                                { value: '4', name: '中专' },
                                                { value: '5', name: '高中' },
                                                { value: '6', name: '初中' },
                                                { value: '7', name: '其他' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: true,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_参加工作时间" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'joinWorkData'" class="field">参加工作时间</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="joinWorkData"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'date', emptyMessage: '请输入参加工作时间', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '参加工作时间', propName: 'joinWorkData', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日', valueMaxLength: null, valueMinLength: null, model: 'vo.joinWorkData', option: [], weekday: 0 }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_家庭住址" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'homeAddress'" class="field">家庭住址</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="homeAddress" :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入家庭住址', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '家庭住址', propName: 'homeAddress', propType: 'String', textFormatter: 'textfield', valueMaxLength: 255, valueMinLength: null, model: 'vo.homeAddress', option: [] }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_紧急联系人" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'linkman'" class="field">紧急联系人</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="linkman"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入紧急联系人', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '紧急联系人', propName: 'linkman', propType: 'String', textFormatter: 'textfield', valueMaxLength: 50, valueMinLength: null, model: 'vo.linkman', option: [], autocomplete: 'off', showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_紧急联系人电话" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'linkmanTel'" class="field">紧急联系人电话</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="linkmanTel"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入紧急联系人电话', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '紧急联系人电话', propName: 'linkmanTel', propType: 'String', textFormatter: 'phone', valueMaxLength: 20, valueMinLength: null, model: 'vo.linkmanTel', option: [], autocomplete: 'off', showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr v-if="!isMypersonalRecords">
                                <td ref="tdlbl_是否开通系统帐号" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'isSysUser'" class="field">是否开通系统帐号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="isSysUser"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：是\n0：否',
                                            elementReadonly: 1,
                                            elementType: 'radio',
                                            emptyMessage: '请选择是否开通系统帐号',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '是否开通系统帐号',
                                            propName: 'isSysUser',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.isSysUser',
                                            option: [
                                                { value: '1', name: '是' },
                                                { value: '0', name: '否' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: true,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit&&noEditSysUser"
                                    />
                                </td>
                                <td ref="tdlbl_人员状态" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'personStatus'" class="field">人员状态</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="personStatus"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：实习\n2：试用\n3：正式\n4：退休\n5：离职',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择人员状态',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '人员状态',
                                            propName: 'personStatus',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.personStatus',
                                            option: [
                                                { value: '1', name: '实习' },
                                                { value: '2', name: '试用' },
                                                { value: '3', name: '正式' },
                                                { value: '4', name: '退休' },
                                                { value: '5', name: '离职' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: true,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_人才标识" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'talentMark'" class="field">人才标识</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="talentMark"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '人才骨干：人才骨干\n青年干部：青年干部',
                                            elementReadonly: 1,
                                            elementType: 'checkbox',
                                            emptyMessage: '请选择人才标识',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 0,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '人才标识',
                                            propName: 'talentMark',
                                            propType: 'String',
                                            textFormatter: null,
                                            valueMaxLength: 20,
                                            valueMinLength: null,
                                            model: 'vo.talentMark',
                                            option: [
                                                { value: '人才骨干', name: '人才骨干' },
                                                { name: '青年干部', value: '青年干部' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: true,
                                            filterable: false,
                                            allowCreate: false,
                                            readonlyShowChecked: 0
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr v-if="!isMypersonalRecords && vo.isSysUser == 1">
                                <td ref="tdlbl_是否开通系统帐号" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'isSysUser'" class="field">帐号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="nativePlace"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入帐号',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '帐号',
                                            propName: 'account',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: 100,
                                            valueMinLength: null,
                                            model: 'vo.account',
                                            option: [],
                                            autocomplete: 'off',
                                            showWordLimit: false,
                                            dialog: 0,
                                            dialogNLevelFilter: '2'
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit&&noEditSysUser"
                                    />
                                </td>
                                <td v-if="noEditSysUser" ref="tdlbl_人员状态" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'personStatus'" class="field">密码</span>
                                </td>
                                <td v-if="noEditSysUser" class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
                                        ref="nativePlace"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入密码',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '密码',
                                            propName: 'password',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: 100,
                                            valueMinLength: null,
                                            model: 'vo.password',
                                            option: [],
                                            autocomplete: 'off',
                                            showWordLimit: false,
                                            dialog: 0,
                                            dialogNLevelFilter: '2'
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit&&noEditSysUser"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    name: 'ArchiveInfo',
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        isMypersonalRecords: { type: Boolean, default: false },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data: function () {
        return {
            loginUser: this.$store.getters.loginUser,
            imageUrl: '',
            fileList: [],
            noEditSysUser: true
        }
    },
    computed: {},
    watch: {
        'vo.idCardNumber'(newVal) {
            if (this.validateIdCard(newVal)) {
                const birthday = this.calculateBirthday(newVal)
                if (!this.vo.birthday) {
                    // this.vo.birthday = birthday
                    this.$set(this.vo, 'birthday', birthday)
                    console.log(birthday, 'birthday')
                }
            }
        },
        'vo.birthday'(newVal) {
            const age = this.calculateage(newVal)

            this.vo.age = age
            this.$set(this.vo, 'age', age)
            console.log(age, 'age')
        }
    },
    created: function () {
        if (this.vo.isSysUser == 1) {
            this.noEditSysUser = false
        }
        if (this.$parent.$vnode.context.activeTabIndex) {
            this.activeTabName = this.$parent.$vnode.context.activeTabIndex
        }
        if (this.vo.idPhotoName) {
            this.imageUrl = this.$vnode.context.urlT + '/rsgl/archiveInfo/download?nameField=idPhotoName&dataField=idPhotoData&id=' + this.vo.id
        }
        this.$set(this.$vnode.context, 'wfAttach', false)
    },
    beforeDestroy: function () {},
    mounted: function () {},
    methods: {
        // 假设这是一个身份证号码的校验函数
        validateIdCard(id) {
            // 首先检查长度
            if (id.length !== 18) {
                return false
            }
            // 对于18位身份证号码，进一步校验前17位数字，并计算校验码
            if (id.length === 18) {
                // 这里简化为只检查日期部分，实际应用中需要完整的校验码计算
                const year = id.substring(6, 10)
                const month = id.substring(10, 12)
                const day = id.substring(12, 14)

                // 简单的日期合法性检查（未考虑闰年、月份天数等）
                if (year < '1900' || year > '2099' || month < '01' || month > '12' || day < '01' || day > '31') {
                    return false
                }
                return true
            }
        },
        selectStaff(row, index, dialogTitle, name) {
            // this.selectRow = row
            const el = {
                dialogTitle,
                index,
                multiple: false,
                attrs: { 'dialog-title': '选择人员', name},
                value: ''
            }
            const vnode = {
                context: this,
                data: {
                    model: { expression: 'selectDialog' },
                    attrs: {}
                }
            }

            this.$bus.emit('RsglOpenSelectDialog', el, { value: 'staff' }, vnode)
        },
        // 假设这是一个计算出生年月日的函数
        calculateBirthday(id) {
            if (id.length !== 18) {
                throw new Error('Invalid ID card number length')
            }
            const year = id.substring(6, 10)
            // 提取月份和日期
            const month = id.substring(10, 12)
            const day = id.substring(12, 14)
            if (!this.vo.planTransferDate) {
                this.calculatePlannedRetirementTime(`${year}-${month}-${day}`)
            }
            // 返回格式化的年月日字符串
            return `${year}-${month}-${day} 00:00:00`
        },
        calculateage(birthDate) {
            const currentDate = new Date()
            const birthDateDate = new Date(birthDate)
            const ageInMilliseconds = currentDate - birthDateDate

            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365))
            return ageInYears
        },
        // 获取预计退休日期
        calculatePlannedRetirementTime(data) {
            this.$http({
                url: '/rsgl/archiveInfo/calculatePlannedRetirementTime',
                params: {
                    date: data
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.vo.planTransferDate = res.body.date
                }
            })
        },
        // 籍贯选择
        onSelectTreeNodeCompleted(val, attr) {
            this.vo.nativePlace = val[0].fullName
            this.vo.provinceId = val[0].fullID.split('-')[0]
            const provinceName = val[0].fullName.split('-')[0]
            if (provinceName === '黑龙江省' || provinceName === '内蒙古自治区' || provinceName === '钓鱼岛') {
                this.vo.provinceName = provinceName.substr(0, 3)
            } else {
                this.vo.provinceName = provinceName.substr(0, 2)
            }
        },
        async handleUploadChange(filed, fileList) {
            console.log(filed, 'filed')
            console.log(fileList, 'fileList')
            if (filed.name.indexOf('.jpg') === -1 && filed.name.indexOf('.png') === -1 && filed.name.indexOf('.JPG') === -1 && filed.name.indexOf('.PNG') === -1) {
                this.$alert('上传文件格式错误', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                })
                return
            }

            filed.id = this.vo.id

            this.fileList = [filed]

            this.vo.idPhotoName = filed.name

            this.imageUrl = URL.createObjectURL(filed.raw)
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            if (selectedNodes.length > 0) {
                this.vo.name = selectedNodes[0].name
                this.vo.sex = selectedNodes[0].sex
                this.vo.idCardNumber = selectedNodes[0].idCardNumber
                this.vo.birthday = selectedNodes[0].birthday
                this.vo.age = selectedNodes[0].age
                this.vo.nativePlace = selectedNodes[0].nativePlace
                this.vo.mobilePhone = selectedNodes[0].mobile
                this.vo.email = selectedNodes[0].email
                this.vo.userId = selectedNodes[0].userId
            }
        }
    }
}
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 153px;
    height: 153px;
    line-height: 153px;
    text-align: center;
}
.avatar {
    width: 153px;
    height: 153px;
    display: block;
}
.ArchiveInfo .el-table .el-table__body-wrapper .el-table__body .tdlbl {
    background: #F2F5FB !important;
}
</style>
